import React, { FC, useState, useEffect, useCallback, useMemo, useRef } from "react";
import { Button, Divider, Drawer, FormLabel, Grid, IconButton, MenuItem, Select, Tab, Tabs, TextField, Typography, Autocomplete, Input, InputAdornment, CircularProgress, Box } from '@mui/material'
import { useDrawerStore } from "../../../hooks/useDrawerStore";
import { CustomTabPanel } from "../../../components/common/CustomTabPanel/CustomTabPanel";
import FiberManualRecordIcon from '@mui/icons-material/FiberManualRecord';
import imagen_prueba from '../../../assets/image/imagen_puerta.png'
import EditIcon from '@mui/icons-material/Edit';
import SaveIcon from '@mui/icons-material/Save';
import AddIcon from '@mui/icons-material/Add';
import RemoveIcon from '@mui/icons-material/Remove';
import { useNavigate } from "react-router-dom";
import { LocalStorageKey, RoutesMap } from "../../../types";
import { readLocalStorage } from "../../../toolbox/helpers/local-storage-helpers";
import AddShoppingCartIcon from '@mui/icons-material/AddShoppingCart';
import { useSearcherStore } from "../../../hooks/useSearcherStore";
import { moneyFormat } from "../../../toolbox/helpers/money-helpers";
import { useDocumentOfSalesStore } from "../../../hooks/useDocumentOfSalesStore";
import { Formik } from "formik";
import { ModalFooter } from "../../../components/common/Modal/ModalFooter";
import { CustomSnackbar } from "../../../components/common/CustomSnackbar/CustomSnackbar";
import { useShoppingCartStore } from "../../../hooks/useShoppingCartStore";
import DeleteOutlineIcon from '@mui/icons-material/DeleteOutline';
import CustomTable from "../../../components/common/CustomTable/CustomTable";
import { useSupplierStore } from "../../../hooks/useSupplierStore";
import { useReferenceDocumentStore } from "../../../hooks/useReferenceDocumentStore";
import { useWayToPayStore } from "../../../hooks/useWayToPayStore";
import { useTicketStore } from "../../../hooks/useTicketStore";
import { useTypeSaleStore } from "../../../hooks/useTypeSaleStore";
import { ProductShoppingCart } from "./ProductShoppingCart";
import { useBussinesAreaStore } from "../../../hooks/useBussinesAreaStore";
import { ApiStatus } from "../../../types/api/status";
import { ClientAddressAPI } from "../../../apis/ClientAddressAPI";
import { useSellerStore } from "../../../hooks/useSellerStore";
import debounce from 'lodash.debounce';

const columns = [
    { type: 'options', field: 'options', label: 'Acciones', align:'center' },
    { type: 'text', field: 'document', label: 'Tipo doc.', align:'center' },
    { type: 'text', field: 'folio', label: 'Folio', align:'center' },
    { type: 'text', field: 'description', label: 'Observación', align:'center' },
];

export const DrawerShoppingCart:FC<any> = (props):JSX.Element|any => {
    const navigate = useNavigate()

    const inputRefGlobal = useRef<HTMLInputElement>(null);
    
    const handleFocus = () => {
        setTimeout(() => {
            inputRefGlobal.current?.focus();
        }, 100); 
    }

    const { getShoppingCart, editCartProduct, deleteProductCart, changeGlobalDiscount } = useShoppingCartStore();
    const { getReferenceDocuments, createReferenceDocument, deleteReferenceDocument } = useReferenceDocumentStore();
    const { status: statusTicket, createTicket } = useTicketStore()
    const { shoppingCart, setShoppingCart } = useDrawerStore();
    const { getWayToPay, getWayToPayByCompany } = useWayToPayStore();
    const { selectedCustomer } = useSearcherStore();
    const { getDocumentOfSales } = useDocumentOfSalesStore();
    const { getSuppliers } = useSupplierStore();
    const { typesSale, getTypesSale } = useTypeSaleStore()

    const userData = readLocalStorage(LocalStorageKey.USER_DATA);
    const idusersession = userData?.id;

    const [loadingcart, setLoadingcart] = useState(false);
    const [loading, setLoading] = useState(false);
    const [loadingReference, setLoadingReference] = useState(false);
    const [loadingSaveReference, setLoadingSaveReference] = useState(false);
    const [panel, setPanel] = useState<number>(0)
    const [products, setProducts] = useState<any>([]);

    const [salesDocument, setSalesDocument] = useState<any>([]);
    const [documentSelected, setDocumentSelected] = useState<any>(null)
    const [typeSales, setTypeSales] = useState<any>([]);
    const [typeSaleSelected, setTypeSaleSelected] = useState<any>(null);
    const [customers, setCustomers] = useState<any>([]);
    const [customerselected, setCustomerselected] = useState<any>('');
    const [paymentMethods, setPaymentMethods] = useState<any>([]);
    const [clientAddresses, setClientAddresses] = useState<any>([]);
    //documentos de referencia
    const [salesDocumentSelected, setSalesDocumentSelected] = useState<any>(null);
    const [folio, setFolio] = useState<any>('');
    const [reference, setReference] = useState<any>('');
    const [references, setReferences] = useState<any>([]);
    const [rowSelected, setRowSelected] = useState<any>('');

    //descuentos por productos
    const [editIndex, setEditIndex] = useState<any>(null);
    const [editedDiscount, setEditedDiscount] = useState<any>('');
    const [discountType, setDiscountType] = useState('1');
    
    //descuento global
    const [editedDiscountGlobal, setEditedDiscountGlobal] = useState<any>(false);
    const [globaldiscount, setglobaldiscount] = useState<any>(0);
    const [discountTypeGlobal, setDiscountTypeGlobal] = useState('1');
    
    const [billingSelected, setBillingSelected] = useState<any>(null);

    const [data, setData] = useState<any>({
        id_customer: selectedCustomer ? selectedCustomer.id : '',
        customer_rut: selectedCustomer ? selectedCustomer.rut : '',
        customer_name: selectedCustomer ? selectedCustomer.name_rz : '',
        client_address: 0,
        idtype_document: '',
        idtype_sales: '',
        net_total: 0,
        gross_total: 0,
        global_discount: 0,
        total_discount: 0,
        IGV: 0,
        total: 0,
        way_to_pay: '',
        status: '1',
        idshopping_cart: 0,
        folio_document: 0
    });

    const { status: statusBussines, bussinesArea, getBussinesAreaByCompany } = useBussinesAreaStore()
    const { status: statusSellers, sellers, getSellersERP} = useSellerStore();
    const [selectedBussines, setSelectedBussines] = useState<any>(null)
    const [selectedSeller, setSelectedSeller] = useState<any>(null)
    const [observation, setObservation] = useState<string>('')

    const [searchTerm, setSearchTerm] = useState('');

    useEffect(() => {
        //combobox
        getWayToPayApi();
        getDocumentsApi();
        getTypeSalesApi();
        // getCustomersApi();
        getBussinesAreaByCompany()
        //productos del carrityo
        getShoppingCartApi();
        getSellersERP();

        //setdata
        if(selectedCustomer) {
            setCustomerselected(selectedCustomer || '');
            getReferenceDocumentsApi(selectedCustomer?.id);
        }
    },[shoppingCart])

    useEffect(() => {
        if(customerselected) getClientAddress(customerselected.id)
    }, [customerselected])

    const getClientAddress = async (idclient) => {
        const response = await ClientAddressAPI.getClientAddress({idclient: idclient})
        if(response?.data?.detail) setClientAddresses(response?.data?.detail)
    }

    const getShoppingCartApi = async() => {
        try {
            setLoadingcart(true);

            setData({
                customer_rut: selectedCustomer ? selectedCustomer.rut : '',
                customer_name: selectedCustomer ? selectedCustomer.name_rz : '',
                idtype_document: '',
                idtype_sales: '',
                net_total: 0,
                gross_total: 0,
                global_discount: 0,
                total_discount: 0,
                IGV: 0,
                total: 0,
                way_to_pay: '',
                status: '1',
            });
            // setProducts([]);

            const datacart = {
                iduser_created: idusersession,
                idcustomer: selectedCustomer?.id,
                status_ticket: 0,
                page: "",
                perPage: ""
            }
            const response = await getShoppingCart(datacart);

            if(response && response.length > 0){
                const {detail, ...otherfields} = response[0];
                setProducts(detail || []);
                setData({
                    ...otherfields,
                    customer_rut: selectedCustomer ? selectedCustomer.rut : '',
                    customer_name: selectedCustomer ? selectedCustomer.name_rz : '',
                    global_discount: otherfields?.global_discount || 0,
                    idshopping_cart: otherfields.id
                })
                const dataBillingFind = salesDocument.find((item) => item.id == otherfields.documenttype.toString())
                
                if(dataBillingFind) {
                    setDocumentSelected(dataBillingFind)
                }

            }
            setLoadingcart(false);
        } catch (error) {
            setLoadingcart(false);
        }
    }

    const getDocumentsApi = async(search='') => {
        try {
            setLoading(true);
            const response = await getDocumentOfSales(search);
            if(!response){
                setSalesDocument([]); setLoading(false);
                return false;
            }else{
                setSalesDocument(response);
                if(response.length > 0 ) {
                    setDocumentSelected(response[0] || null)
                    setSalesDocumentSelected(response[0] || '')
                };
                setLoading(false);
            }
        } catch (error) {
            setLoading(false);
        }
    }

    const getTypeSalesApi = async() => {
        try {
            setLoading(true);
            const response = await getTypesSale();
            if(!response){
                setTypeSales([]); setLoading(false);
                return false;
            }else{
                setTypeSales(typesSale);
                if(response.length > 0 ) setTypeSaleSelected(response[0] || '');
                setLoading(false);
            }
        } catch (error) {
            setLoading(false);
        }
    }

    const getCustomersApi = async() => {
        try {
            setLoading(true);
            const response = await getSuppliers({type:1});
            if(!response){
                setCustomers([]);
                setLoading(false);
                return false;
            }else{
                setCustomers(response);
                setLoading(false);
            }
        } catch (error) {
            setLoading(false);
        }
    }

    const debouncedSearch = useMemo(
        () =>
            debounce(async (query) => {
                setLoading(true);
                try {
                    const response = await getSuppliers({ type: 1, name_rz: query });
                    setCustomers(response || []);
                } catch (error) {
                    console.error('Error fetching suppliers:', error);
                    setCustomers([]);
                } finally {
                    setLoading(false);
                }
            }, 500),
        []
    );

    const handleInputChange = (event, value) => {
        setSearchTerm(value);
        if (value) {
            debouncedSearch(value);
        } else {
            setCustomers([]);
        }
    };

    const getWayToPayApi = async(search='') => {
        try {
            setLoading(true);
            const response = await getWayToPayByCompany(search);
            const newData:any = [];
            response && (response).length > 0 && (response).map((item)=>{
                newData.push({
                    ...item, 
                    idcuotas: JSON.parse(item.idcuotas),
                    idtools: JSON.parse(item.idtools),
                })
            })
            setPaymentMethods(newData || []);
            setLoading(false);
        } catch (error) {
            setLoading(false);
        }
    }

    const editCartProductAPI = async(iddetail, data)  => {
        setLoadingcart(true);

        const response:any = await editCartProduct(iddetail, data);
        if(response){
            getShoppingCartApi();
            setLoadingcart(false);
        }else{
            setLoadingcart(false);
            return false;
        }
    }

    const changeGlobalDiscountAPI = async(idcart, data)  => {
        setLoadingcart(true);

        const response:any = await changeGlobalDiscount(idcart, data);
        if(response){
            getShoppingCartApi();
            setLoadingcart(false);
        }else{
            setLoadingcart(false);
            return false;
        }
    }

    const deleteProductCartAPI = async(iddetail) => {
        setLoadingcart(true);
        const response = await deleteProductCart(iddetail)
        if(response){
            getShoppingCartApi();
            setLoadingcart(false);
        }else{
            setLoadingcart(false);
            return false;
        }
    }

    const handleDismissProduct = (index: number) => {

        let card = [...products];
        let updatedProduct = { ...card[index] };
        updatedProduct.quantity = parseInt(updatedProduct.quantity) - 1;
        card[index] = updatedProduct;
    
        const data = {
            quantity: updatedProduct.quantity,
            discount: updatedProduct.discount || 0,
        };
    
        editCartProductAPI(updatedProduct.id, data);
    }

    const handleInputQuantityChange = (e: React.ChangeEvent<HTMLInputElement>, index: number) => {
        const value = parseInt(e.target.value, 10);

            let card = [...products];
            let updatedProduct = { ...card[index] };
            updatedProduct.quantity = value;
            card[index] = updatedProduct;
    
            setProducts(card); 
    
            const data = {
                quantity: updatedProduct.quantity,
                discount: updatedProduct.discount || 0,
            };
    
            debouncedEditCartProductAPI(updatedProduct.id, data);
    };  

    const validateQuantity = (index: number) => {
        let card = [...products];
        let updatedProduct = { ...card[index] };
        const value = parseInt(updatedProduct.quantity as any, 10);
    
        if (isNaN(value) || value < 1) {
            updatedProduct.quantity = 1; 
        } else {
            updatedProduct.quantity = value;
        }
    
        card[index] = updatedProduct;
        setProducts(card);
    
        const data = {
            quantity: updatedProduct.quantity,
            discount: updatedProduct.discount || 0,
        };
    
        debouncedEditCartProductAPI(updatedProduct.id, data);
    };
    
    const debouncedEditCartProductAPI = useCallback(
        debounce((id, data) => {
            editCartProductAPI(id, data);
        }, 500), 
        []
    );
    

    const handleMoreProduct = (index: number) => {
        
        let card = [...products];
        let updatedProduct = { ...card[index] };
        updatedProduct.quantity = parseInt(updatedProduct.quantity) + 1;
        card[index] = updatedProduct;
    
        const data = {
            quantity: updatedProduct.quantity,
            discount: updatedProduct.discount || 0,
        };
    
        editCartProductAPI(updatedProduct.id, data);
    
    };

    const handleDocumentType = (documenttype) => {
        let card = [...products];
        let updatedProduct = { ...card[0] };

        const data = {
            documenttype: documenttype.id.toString(),
        };

        editCartProductAPI(updatedProduct.id, data);

    }
    

    const handleChangePanel = (event: React.SyntheticEvent, newValue: number) => {
        setPanel(newValue);
        // changeNextPanel();
    }

    const handleEditDiscount = (index) => {
        setEditIndex(index);
        setEditedDiscount(products[index].discount.toString()); // Inicializa el input con el valor actual del descuento
    };

    const nameDiscount = (type) => {
        switch (type) {
            case '1':
                return '$'
            case '2':
                return '%'
            case '3':
                return 'sin dto'
        }
    }

    const handleKeyDown = (event) => {
        const keyCode = event.keyCode || event.which;
        if (keyCode === 189 || keyCode === 109) {
          event.preventDefault();
        }
    };

    const handleSaveDiscount = (index) => {

        let card: Array<any> = products;
        let maxdesc = discountType ==='2' ? 100 : card[index].max_desc_item_pricelist;
        if( maxdesc && editedDiscount > maxdesc) return CustomSnackbar('error', `El máximo descuento por item es: ${maxdesc}`);

        const data = {
            quantity: card[index].quantity,
            discount: editedDiscount || 0,
            discountType : parseInt(discountType)
        }
        editCartProductAPI(card[index]?.id, data);

        setEditIndex(null);
        setEditedDiscount('');
    };

    const handleSaveDiscountGlobal = (idcart) => {
        if(products.length == 0) return CustomSnackbar('error', `Aún no tienes productos en tu carrito`);
        let maxdesc = products[0].max_desc_global_pricelist || 0;
        if( maxdesc && globaldiscount > maxdesc) return CustomSnackbar('error', `El máximo descuento por global es: ${maxdesc}`);

        const data = {
            global_discount: globaldiscount || 0,
            discounttype: parseInt(discountTypeGlobal)
        }
        changeGlobalDiscountAPI(idcart, data);

        setData({...data, global_discount: globaldiscount})
        setEditedDiscountGlobal(false)
    }

    const getReferenceDocumentsApi = async(idcustomer) => {
        try {
            setLoadingReference(true);
            const response = await getReferenceDocuments({idcustomer: idcustomer});
            if(!response){
                setReferences([]);
                setLoadingReference(false);
                return false;
            }else{
                setReferences(response || []);
                setLoadingReference(false);
            }
        } catch (error) {
            setLoadingReference(false);
        }
    }

    const addReference = async() => {

        if(!salesDocumentSelected) return CustomSnackbar('error', "Seleccione un tipo de documento");
        if(!customerselected) return CustomSnackbar('error', "Seleccione un cliente");
        setLoadingSaveReference(true);

        const data = {
            folio: folio,
            description:reference,
            iddocument_of_sale:salesDocumentSelected.id,
            idcustomer:customerselected.id,
        }

        const response:any = await createReferenceDocument(data);
        if(response){
            getReferenceDocumentsApi(customerselected?.id);
            clearInputs();
            setLoadingSaveReference(false);
        }else{
            setLoadingSaveReference(false);
            return false;
        }
    }

    const onDelete = async(rowSelected:any) => {
        if (rowSelected) {
            setLoadingReference(true);
            const response = await deleteReferenceDocument(rowSelected.id)
            if(response){
                getReferenceDocumentsApi(selectedCustomer?.id);
                setLoadingReference(false);
                // setRowSelected('');
            }else{
                setLoadingReference(false);
                return false;
            }
        }
    }

    const clearInputs = () => {
        setSalesDocumentSelected(null)
        setFolio('')
        setReference('')
    }

    const validateForm = (values) => {
        let errors:any = {};
        if(!values.customer_rut) errors.customer_rut = "el campo es requerido";
        if(!values.customer_name) errors.customer_name = "el campo es requerido";
        if(!values.way_to_pay) errors.way_to_pay = "el campo es requerido";
        return errors;
    }

    const changeNextPanel = () => {
        if (salesDocumentSelected === null) return CustomSnackbar('warning', 'Seleccione un tipo de documento')
        if (typeSaleSelected === null) return CustomSnackbar('warning', 'Seleccione un tipo de venta')

        setPanel(1)
        setData({
            ...data,
            customer_rut: selectedCustomer ? selectedCustomer.rut : '',
            customer_name: selectedCustomer ? selectedCustomer.name_rz : '',
            idtype_document: salesDocumentSelected?.id,
            idtype_sales: typeSaleSelected?.id,
        })
    }

    const previousPannel = () => {
        setPanel(0)
    }

    const onSubmit = async(values)  => {
        // const datarefrences = (references ?? []).map(reference => (
        //     { id:reference.id, description:reference.description, iddocument_of_sale:reference.iddocument_of_sale, document:reference.document, folio:reference.folio   }
        // ));
        // const params:any = {
        //     ...data,
        //     customer_rut: selectedCustomer?.rut ?? values.customer_rut,
        //     customer_name: selectedCustomer?.name_rz ?? values.customer_name,
        //     way_to_pay: values?.way_to_pay ?? '',
        //     references: datarefrences ?? [],
        //     products: products
        // }
        const payload:any = {
            idshopping_cart: data.idshopping_cart,
            idtype_document: documentSelected.id,
            idtype_sale: typeSaleSelected.id,
            idway_to_pay: values.way_to_pay,
            folio: values.folio_document,
            customer_rut: selectedCustomer?.rut ?? values.customer_rut,
            customer_name: selectedCustomer?.name_rz ?? values.customer_name,
            observation: observation, 
            bussines_area: selectedBussines.iderp,
            seller_rut: selectedSeller?.rut_vendedor,
            idclient_address: values.client_address
        }
        const response = await createTicket(payload)
        if (response.id) navigate(`/preview-document/${response.id}`)
        // if (response.id) navigate(`/preview-document/${response.id}`, {state: {data:params}})
    }

    const filterOptions = (options, { inputValue }) => {
        const normalizedInput = inputValue.toLowerCase();
        return options.filter(option =>
            option.name_rz.toLowerCase().includes(normalizedInput) ||
            option.rut.toLowerCase().includes(normalizedInput)
        );
    };

    return (
        <Drawer anchor="right" open={shoppingCart} onClose={() => setShoppingCart(false)} ModalProps={{ keepMounted: true }} PaperProps={{ sx: { width: 900 }}}>
            <Grid display="flex" justifyContent="center">
                <Tabs value={panel} onChange={handleChangePanel}
                    sx={{
                        "& .MuiTabs-indicator": {
                            height: 0
                        },
                        justifyContent: 'center'
                    }}
                >
                    <Tab 
                        icon={<FiberManualRecordIcon
                            sx={{
                                color: panel == 0 ? '#858585' : '#D9D9D9',
                                fontSize: panel == 0 ? 'large' : 'small',
                            }}
                        />}
                        sx={{ minWidth: '5px' }}
                    />
                    <Tab 
                        icon={<FiberManualRecordIcon
                            sx={{
                                color: panel == 1 ? '#858585' : '#D9D9D9',
                                fontSize: panel == 1 ? 'large' : 'small',
                            }}
                        />}
                        sx={{ minWidth: '5px' }}
                    />
                </Tabs>
            </Grid>

            <CustomTabPanel value={panel} index={0}>
                <Grid container sx={{ display: 'flex', justifyContent: 'space-between', padding:'20px' }}>
                    <Typography variant="h5" sx={{ color: '#516E80', fontWeight: '700' }}> Paso 1: Articulos del carrito</Typography>
                    {/* <Button
                        sx={{ backgroundColor: '#ffffff', border: '1px solid #516E80', borderRadius: '10px', color: '#516E80', height: '25px', textTransform: 'none', width: 160, "&:hover": { backgroundColor: "#ffffff" } }}
                    >Guardar cambios</Button> */}
                </Grid>

                <Divider sx={{ backgroundColor: '#516E80', margin: '10px 0px' }}/>

                {
                  false && <Grid container item justifyContent={'center'} alignItems='center' overflow="auto" sx={{ marginTop: '10px', height: '50vh', padding: '20px' }} >
                        {
                            products && products.length > 0 && products.map((product, i) =>
                                <>
                                    <Grid item container xs={12} md={12} sx={{ backgroundColor: '#F5F5F5', margin: '5px', padding: '5px', justifyContent: 'space-between' }}>

                                        <Grid item xs={3} md={3} display='flex' justifyContent='center' alignItems='center'>
                                            <img src={imagen_prueba} alt={product.name_product} style={{ width: '70px', height: '70px' }} />
                                        </Grid>

                                        <Grid item xs={9} md={9}>
                                            <Grid sx={{ width: '100%', display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                                                <Typography sx={{ color: '#000000', fontSize: '15px', width: '200px', marginRight: '3px' }}>{'SKU12345678'}</Typography>
                                                <IconButton onClick={() => deleteProductCartAPI(product?.id)}>
                                                    <DeleteOutlineIcon fontSize="small" />
                                                </IconButton>
                                            </Grid>
                                            <Grid sx={{ width: '100%', display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                                                <Grid sx={{ display: 'flex', alignItems: 'center' }}>
                                                    <Typography sx={{ color: '#000000', width: '200px' }}>{product.name_product}</Typography>
                                                    {editIndex === i ? (
                                                        <>
                                                            <Input
                                                                type="number"
                                                                value={editedDiscount}
                                                                onChange={(e) => setEditedDiscount(e.target.value)}
                                                                endAdornment={<InputAdornment position="end">{nameDiscount(product.discounttype_pricelist)}</InputAdornment>}
                                                                sx={{ maxWidth: '65px' }}
                                                                onKeyDown={handleKeyDown}
                                                                inputProps={{
                                                                    min: 0
                                                                }}
                                                            />
                                                            <IconButton onClick={() => handleSaveDiscount(i)}>
                                                                <SaveIcon fontSize="small" />
                                                            </IconButton>
                                                        </>
                                                    ) : (
                                                        <>
                                                            {
                                                                product.discounttype_pricelist == '3' && (
                                                                    <Typography sx={{ backgroundColor: '#FF4747', borderRadius: '5px', color: '#ffffff', padding: '2px', fontSize: '13px' }}>
                                                                        {nameDiscount(product.discounttype_pricelist)}
                                                                    </Typography>
                                                                )
                                                            }
                                                            {
                                                                product.discounttype_pricelist != '3' && (
                                                                    <>
                                                                        <Typography sx={{ backgroundColor: '#FF4747', borderRadius: '5px', color: '#ffffff', padding: '2px', fontSize: '13px' }}>
                                                                            -{product.discount} {nameDiscount(product.discounttype_pricelist)}
                                                                        </Typography>
                                                                        <IconButton onClick={() => {handleEditDiscount(i); handleFocus();}}>
                                                                            <EditIcon fontSize="small" />
                                                                        </IconButton>
                                                                    </>
                                                                )
                                                            }
                                                        </>
                                                    )}
                                                </Grid>
                                                <Grid>
                                                    <div>
                                                        <Typography sx={{ color: '#000000', fontWeight: 'bolder' }}>
                                                            {
                                                                product.offer_price != 0 ? moneyFormat(product.offer_price, '$') :
                                                                    (product.price ? moneyFormat(product.price, '$') : '$ 0')
                                                            }
                                                        </Typography>
                                                        <Typography sx={{ color: '#000000', fontWeight: 'bolder' }}>
                                                            {
                                                                product.gross_subtotal != 0 && moneyFormat(product.gross_subtotal, '$')
                                                            }
                                                        </Typography>
                                                    </div>
                                                    {/* <div>
                                         {
                                             product.offer_price != 0 && (
                                                 <Typography sx={{textDecoration: 'line-through', color: 'red'}}>
                                                     {moneyFormat(product.price, '$')  || '$ 0'}
                                                 </Typography>
                                             )
                                         }
                                         </div> */}
                                                </Grid>
                                            </Grid>
                                            <Grid>
                                                <Typography sx={{ fontSize: '15px' }}>Cantidad:</Typography>
                                                <IconButton
                                                    sx={{ background: '#516E80', marginLeft: '10px', width: '20px', height: '20px', '&:hover': { background: '#516E80' } }}
                                                    onClick={() => handleDismissProduct(i)}
                                                >
                                                    <RemoveIcon sx={{ color: '#ffffff', width: '15px', height: '15px' }} />
                                                </IconButton>
                                                <Typography sx={{ fontSize: '15px', marginLeft: '10px' }}>{product?.quantity}</Typography>
                                                <IconButton
                                                    sx={{ background: '#516E80', marginLeft: '10px', width: '20px', height: '20px', '&:hover': { background: '#516E80' } }}
                                                    onClick={() => handleMoreProduct(i)}
                                                >
                                                    <AddIcon sx={{ color: '#ffffff', width: '15px', height: '15px' }} />
                                                </IconButton>
                                            </Grid>
                                        </Grid>
                                    </Grid>
                                </>
                            )
                        }
                        {
                            products && products.length === 0 && (
                                <Grid xs={12} alignItems='center' alignContent='center' justifyContent='center'>
                                    <Grid item xs={12} className="icoCard" alignContent='center' >
                                        <IconButton  >
                                            <AddShoppingCartIcon sx={{ fontSize: '50px' }} />
                                        </IconButton>
                                    </Grid >

                                    <Grid xs={12} item justifyContent={'space-between'} alignItems='center' >
                                        <Typography className='textbody' sx={{ color: '#3f3f3f ' }} >Aun no tienes productos en tu canasta</Typography>
                                    </Grid>
                                </Grid>
                            )
                        }
                    </Grid>
                }

                <Grid container spacing={2} sx={{ marginTop: '10px', paddingX: '20px' }}>
                    <Grid item xs={6}>
                        <FormLabel sx={{ color: '#000000' }}>Tipo de documento:</FormLabel>
                        <Autocomplete
                            id="idtype_document"
                            size="small"
                            value={!!documentSelected ? documentSelected  : null}
                            options={salesDocument || []}
                            getOptionLabel={(option) => option?.name || ''}
                            isOptionEqualToValue={(option, value) => option.name === value?.name}
                            renderInput={(params) =>
                                <TextField {...params} label="" size="small" />
                            }
                            onChange={(e, newValue: any) => {
                                setDocumentSelected(newValue)
                                handleDocumentType(newValue)
                            }}

                        />
                    </Grid>
                </Grid>

                <ProductShoppingCart
                    products={products}
                    deleteProductCartAPI = {deleteProductCartAPI}
                    handleDismissProduct = {handleDismissProduct}
                    handleMoreProduct= {handleMoreProduct}
                    handleInputQuantityChange= {handleInputQuantityChange}
                    validateQuantity= {validateQuantity}
                    discountType = {discountType}
                    setDiscountType = {setDiscountType}
                    editIndex = {editIndex}
                    editedDiscount = {editedDiscount}
                    setEditedDiscount = {setEditedDiscount}
                    handleSaveDiscount = {handleSaveDiscount}
                    handleEditDiscount = {handleEditDiscount}
                />

                <Grid item container xs={12} sx={{ marginTop: '10px', marginLeft: '5px', paddingX: '20px' }}>
                    <Grid xs={12}>
                        <Typography sx={{ color: '#000000', fontWeight: 'bolder' }}>Resumen</Typography>
                    </Grid>
                    {/* <Grid item xs={12} md={6} >
                        <Grid display='flex' alignItems='center'>
                            <Typography variant="subtitle1" sx={{width:'200px'}}>Puntos acumulados:</Typography>
                            <Typography variant="body1" sx={{width:'200px'}}>{'3 puntos'}</Typography>
                        </Grid>
                    </Grid> */}
                </Grid>

                <Grid item container xs={12} sx={{ marginTop: '10px', marginLeft: '5px', paddingX: '20px' }}>
                <Grid item xs={12} md={6}>
                        <Grid display='flex' alignItems='center'>
                            <Typography variant="subtitle1" sx={{width:'200px'}}>Subtotal:</Typography>
                            <Typography variant="body1" sx={{width:'200px', fontWeight: 'bolder', color: '#000000'}}>
                                {moneyFormat(data?.sub_total, '$')  || '$ 0'}
                            </Typography>
                        </Grid>
                        <Grid display='flex' alignItems='center'>
                            <Typography variant="subtitle1" sx={{width:'157px'}}>Descuento global:</Typography>
                            {editedDiscountGlobal ? (
                                <Box display="flex" alignItems="center" gap={1}>
                                
                                <TextField
                                    type="number"
                                    value={globaldiscount}
                                    onChange={(e) => {
                                        const value = parseFloat(e.target.value);
                                        if (discountTypeGlobal === '2' && value > 100) {
                                            setglobaldiscount(100); // Limita al 100 si es porcentaje
                                        } else if (value < 0) {
                                            setglobaldiscount(0); // Evita valores negativos
                                        } else {
                                            setglobaldiscount(value);
                                        }
                                    }}
                                    sx={{maxWidth: '80px'}}
                                    size="small"
                                    onKeyDown={
                                        (e) => {
                                            if (e.key === 'Enter') {
                                                handleSaveDiscountGlobal(data?.id); 
                                            }else{
                                                handleKeyDown(e)
                                            }
                                        } 
                                    }
                                    inputProps={{
                                        min: 0
                                    }}
                                    inputRef={inputRefGlobal}
                                />
                                <Select
                                    value={discountTypeGlobal}
                                    onChange={(e) => setDiscountTypeGlobal(e.target.value)}
                                    size="small"
                                    sx={{ maxWidth: '80px' }}
                                >
                                    <MenuItem value="2">%</MenuItem>
                                    <MenuItem value="1">$</MenuItem>
                                </Select>
                                <IconButton onClick={()=>handleSaveDiscountGlobal(data?.id)}>
                                    <SaveIcon fontSize="small" />
                                </IconButton>
                                </Box>
                            ) : (
                                <>
                                <Typography sx={{ paddingLeft: '50px', fontWeight: 'bolder', color: '#000000'}} >
                                    {  data?.discounttype == 1  && moneyFormat(data?.global_discount || 0, '$')}
                                    {  data?.discounttype == 2  && data?.global_discount + " %" }
                                </Typography>
                                <IconButton onClick={()=>{setEditedDiscountGlobal(true); handleFocus();}}>
                                    <EditIcon fontSize="small"/>
                                </IconButton>
                                </>
                            )}
                        </Grid>
                        <Grid display='flex' alignItems='center'>
                            <Typography variant="subtitle1" sx={{width:'200px'}}>Descuento Global ($):</Typography>
                            <Typography variant="body1" sx={{width:'200px', fontWeight: 'bolder', color: '#000000'}}>
                                {moneyFormat(data?.sub_total - data?.net_total, '$')  || '$ 0'}
                            </Typography>
                        </Grid>
                    </Grid>
                    <Grid item xs={12} md={6} >
                        <Grid display='flex' alignItems='center'>
                            <Typography variant="subtitle1" sx={{width:'200px'}}>Total neto:</Typography>
                            <Typography variant="body1" sx={{width:'200px', fontWeight: 'bolder', color: '#000000'}}>
                                {moneyFormat(data?.net_total, '$')  || '$ 0'}
                            </Typography>
                        </Grid>
                        <Grid display='flex' alignItems='center'>
                            <Typography variant="subtitle1" sx={{width:'200px'}}>IVA:</Typography>
                            <Typography variant="body1" sx={{width:'200px', fontWeight: 'bolder', color: '#000000'}}>{moneyFormat(data?.IGV, '$')}</Typography>
                        </Grid>
                        <Grid display='flex' alignItems='center'>
                            <Typography variant="subtitle1" sx={{width:'200px'}}>Total bruto:</Typography>
                            <Typography variant="body1" sx={{width:'200px', fontWeight: 'bolder', color: '#000000'}}>
                                {moneyFormat(data?.gross_total, '$')  || '$ 0'}
                            </Typography>
                        </Grid>
                    </Grid>
                </Grid>

                <Grid container spacing={2} sx={{ marginTop: '10px', paddingX: '20px' }}>
                    {/* <Grid item xs={6}>
                        <FormLabel sx={{ color: '#000000' }}>Tipo de documento:</FormLabel>
                        <Autocomplete
                            id="idtype_document"
                            size="small"
                            value={!!documentSelected ? documentSelected : null}
                            options={salesDocument || []}
                            getOptionLabel={(option) => option?.name || ''}
                            isOptionEqualToValue={(option,value)=> option.name === value?.name} 
                            renderInput={(params) => 
                                <TextField {...params} label="" size="small"/>
                            }
                            onChange={(e, newValue: any) => {
                                setDocumentSelected(newValue);
                            }}
                            
                        />
                    </Grid> */}
                    {/* <Grid item xs={6}>
                        <FormLabel sx={{ color: '#000000' }}>Tipo de venta:</FormLabel>
                        <Autocomplete
                            id="idtype_sales"
                            size="small"
                            value={!!typeSaleSelected ? typeSaleSelected : null}
                            options={typeSales || []}
                            getOptionLabel={(option) => option?.name || ''}
                            isOptionEqualToValue={(option,value)=> option.name === value?.name} 
                            renderInput={(params) => 
                                <TextField {...params} label="" size="small"/>
                            }
                            onChange={(e, newValue: any) => {
                                setTypeSaleSelected(newValue);
                            }}
                            
                        />
                    </Grid> */}
                </Grid>

                <Grid container sx={{ marginTop: '20px', justifyContent: 'flex-end', paddingX: '20px', marginBottom: '30px' }}>
                    <Button size="small" variant="contained" className='btn-confirm' onClick={() => changeNextPanel()}>
                        Continuar
                    </Button>
                </Grid>
            </CustomTabPanel>

            <CustomTabPanel value={panel} index={1} >
                <Grid style={{ padding: '20px'}}>
                <Grid container sx={{ display: 'flex', justifyContent: 'space-between', paddingX: '20px' }}>
                    <Typography variant="h5" sx={{ color: '#516E80', fontWeight:'700' }}>Paso 2: Datos comerciales</Typography>
                </Grid>
                <Divider sx={{ backgroundColor: '#516E80', margin: '10px 0px' }}/>

                <Formik initialValues={data} enableReinitialize validate={ (values) => validateForm(values) } onSubmit={onSubmit}>
                    {({values, errors, touched, handleSubmit, handleChange, setFieldValue}) => {
                        return (
                            <form onSubmit={handleSubmit}>
                                <Grid container sx={{ alignItems: "center", marginTop: '10px' }}>
                                    <Grid item xs={4}>
                                        <FormLabel sx={{ color: '#000000' }}>Razón social / Nombre:</FormLabel>
                                    </Grid>
                                    <Grid item xs={8}>
                                        <Autocomplete
                                            id="customer_name"
                                            size="small"
                                            value={customerselected || null}
                                            options={customers || []}
                                            loading={loading}
                                            getOptionLabel={(option) => `${option.rut} - ${option.name_rz}`}
                                            isOptionEqualToValue={(option, value) => option.name_rz === value?.name_rz}
                                            renderInput={(params) => (
                                                <TextField
                                                    {...params}
                                                    label="Buscar cliente"
                                                    size="small"
                                                    error={false} // Ajusta según la lógica de validación
                                                    InputProps={{
                                                        ...params.InputProps,
                                                        endAdornment: (
                                                            <>
                                                                {loading ? <CircularProgress color="inherit" size={20} /> : null}
                                                                {params.InputProps.endAdornment}
                                                            </>
                                                        ),
                                                    }}
                                                    onChange={(e) => handleInputChange(e, e.target.value)} // Captura el cambio en el input
                                                />
                                            )}
                                            onChange={(e, newValue) => {
                                                setCustomerselected(newValue);
                                                // Actualiza los valores en el formulario
                                                setFieldValue('id_customer', newValue ? newValue.id : '');
                                                setFieldValue('customer_name', newValue ? newValue.name_rz : '');
                                                setFieldValue('customer_rut', newValue ? newValue.rut : '');
                                                getReferenceDocumentsApi(newValue?.id);
                                            }}
                                        />
                                    </Grid>
                                </Grid>
                                <Grid container sx={{ marginTop: '10px' }} alignItems="center">
                                    <Grid item xs={4}>
                                        <FormLabel sx={{ color: '#000000' }}>Rut de cliente:</FormLabel>
                                    </Grid>
                                    <Grid item xs={8}>
                                        <TextField
                                            id="customer_rut"
                                            type="text"
                                            name="customer_rut"
                                            fullWidth
                                            size="small"
                                            value={values?.customer_rut}
                                            onChange={handleChange}
                                            variant="outlined"
                                            disabled
                                            error={errors.customer_rut && touched.customer_rut ? true : false}
                                        />
                                    </Grid>
                                </Grid>

                                <Grid container sx={{ marginTop: '10px' }} alignItems="center">
                                    <Grid item xs={4}>
                                        <FormLabel sx={{ color: '#000000' }}>Dirección de cliente:</FormLabel>
                                    </Grid>
                                    <Grid item xs={8}>
                                        <Select
                                            id="client_address"
                                            name='client_address'
                                            value={values.client_address}
                                            onChange={(event) => {
                                                setFieldValue("client_address", event.target.value);
                                            }}
                                            error={errors.client_address ? true : false}
                                            fullWidth
                                            size="small"
                                        >
                                            {
                                                clientAddresses.length > 0 && clientAddresses.map((item) => (
                                                    <MenuItem value={item.id}>{item.address}</MenuItem>
                                                ))
                                            }
                                        </Select>
                                    </Grid>
                                </Grid>

                                <Divider sx={{ margin: '20px 0px 10px 0px' }} />
                                <Grid container sx={{ marginTop: '10px' }} spacing={2}>
                                    {/* <Grid item xs={6}>
                                        <FormLabel sx={{ color: '#000000' }}>Condición de pago:</FormLabel>
                                        <Select
                                            labelId="type-sale-label"
                                            id="type_sale"
                                            value={1}
                                            onChange={handleChange}
                                            fullWidth
                                            size="small"
                                            sx={{ borderRadius: "15px" }}
                                        >
                                            <MenuItem value={1}>30 días</MenuItem>
                                        </Select>
                                    </Grid> */}
                                    <Grid item xs={6}>
                                        <FormLabel sx={{ color: '#000000' }}>Forma de pago:</FormLabel>
                                        <Select
                                            id="way_to_pay"
                                            name='way_to_pay'
                                            value={values.way_to_pay}
                                            onChange={(event) => {
                                                setFieldValue("way_to_pay", event.target.value);
                                            }}
                                            error={errors.way_to_pay ? true : false}
                                            fullWidth
                                            size="small"
                                        >
                                            {
                                                paymentMethods.length > 0 && paymentMethods.map((item) => (
                                                    <MenuItem value={item.idway_to_pay}>{item.wayToPay}</MenuItem>
                                                ))
                                            }
                                        </Select>
                                    </Grid>
                                    <Grid item xs={6}>
                                        <FormLabel sx={{ color: '#000000' }}>Folio del documento:</FormLabel>
                                        <TextField
                                            id="folio_document"
                                            type="text"
                                            name="folio_document"
                                            fullWidth
                                            size="small"
                                            value={values.folio_document}
                                            onChange={(e) => { setFieldValue('folio_document', e.target.value) }}
                                            variant="outlined"
                                        />
                                    </Grid>
                                </Grid>

                                {/* <Divider sx={{ mkargin: '15px 0px' }} /> */}
                                {
                                    /*Si es nota de debito o credito agregar referencias */
                                    (documentSelected.id === 3 || documentSelected.id === 4) && (<>
                                        <Grid item xs={12}>
                                            <Typography sx={{ color: '#000000', fontWeight: 'bolder' }}>Referencias</Typography>
                                        </Grid>
                                        <Grid container sx={{ marginTop: '5px', marginBottom: '10px' }} spacing={2}>
                                            <Grid item xs={6}>
                                                <FormLabel sx={{ color: '#000000' }}>Tipo de documento:</FormLabel>
                                                <Autocomplete
                                                    id="type_sale"
                                                    size="small"
                                                    value={!!salesDocumentSelected ? salesDocumentSelected : null}
                                                    options={salesDocument || []}
                                                    getOptionLabel={(option) => option?.name || ''}
                                                    isOptionEqualToValue={(option, value) => option.name === value?.name}
                                                    renderInput={(params) =>
                                                        <TextField {...params} label="" size="small" />
                                                    }
                                                    onChange={(e, newValue: any) => {
                                                        setSalesDocumentSelected(newValue)
                                                    }}

                                                />
                                            </Grid>
                                            <Grid item xs={12} md={6}>
                                                <FormLabel sx={{ color: '#000000' }}>Folio documento:</FormLabel>
                                                <TextField
                                                    id="folio"
                                                    type="text"
                                                    name="folio"
                                                    fullWidth
                                                    size="small"
                                                    value={folio}
                                                    onChange={(e) => { setFolio(e.target.value) }}
                                                    variant="outlined"
                                                />
                                            </Grid>
                                            <Grid item xs={12} md={6}>
                                                <FormLabel sx={{ color: '#000000' }}>Razón de referencia:</FormLabel>
                                                <TextField
                                                    id="reference"
                                                    type="text"
                                                    name="reference"
                                                    fullWidth
                                                    size="small"
                                                    value={reference}
                                                    onChange={(e) => { setReference(e.target.value) }}
                                                    variant="outlined"
                                                />
                                            </Grid>
                                        </Grid>
                                        <Grid item xs={12} sx={{ display: 'flex', justifyContent: 'center' }}>
                                            <Button
                                                sx={{ backgroundColor: '#ffffff', border: '1px solid #69ABC3', borderRadius: '10px', color: '#69ABC3', height: '25px', padding: '6px 16px', textTransform: 'none', width: 180, "&:hover": { backgroundColor: "#ffffff" } }}
                                                onClick={addReference}
                                            >
                                                Guardar cambios
                                                {
                                                    loadingSaveReference && (
                                                        <CircularProgress color="inherit" size={12} sx={{ color: '#5b5b5b', marginLeft: "10px" }} />
                                                    )
                                                }
                                            </Button>
                                        </Grid>
                                        <Grid item xs={12}>
                                            <CustomTable
                                                disabled_title
                                                columns={columns}
                                                loading={loadingReference}
                                                rows={references || []}
                                                onRowClick={() => { }}
                                                hasOptions
                                                onDelete={onDelete}
                                                RowsPerPage={3}
                                                dense
                                            />
                                        </Grid>
                                    </>)
                                }

                                <Grid container sx={{ marginTop: '10px' }} spacing={2}>

                                    <Grid item xs={6}>
                                        <FormLabel sx={{ color: '#000000' }}>Área de negocio:</FormLabel>
                                        <Autocomplete
                                            disablePortal
                                            id="combo-box-bussines-area"
                                            value={selectedBussines}
                                            options={statusBussines === ApiStatus.FETCHING ? [] : bussinesArea}
                                            getOptionLabel={(option) => option.name || ""}
                                            isOptionEqualToValue={(option, value) => option?.id === value?.id}
                                            fullWidth
                                            renderInput={(params) =>
                                                <TextField {...params} size="small"
                                                    InputProps={{
                                                        ...params.InputProps,
                                                        endAdornment: (
                                                            <React.Fragment>
                                                                {statusBussines === ApiStatus.FETCHING && <CircularProgress color="inherit" size={20} />}
                                                                {params.InputProps.endAdornment}
                                                            </React.Fragment>
                                                        ),
                                                    }}
                                                />
                                            }
                                            onChange={(e, newValue) => {
                                                setSelectedBussines(newValue);
                                            }}
                                        />
                                    </Grid>
                                    <Grid item xs={6}>
                                        <FormLabel sx={{ color: '#000000' }}>Vendedor:</FormLabel>
                                        <Autocomplete
                                            disablePortal
                                            id="combo-box-seller"
                                            value={selectedSeller}
                                            options={statusSellers === ApiStatus.FETCHING ? [] : sellers}
                                            getOptionLabel={(option) => option.rut_vendedor + " " + option.nombre || ""}
                                            isOptionEqualToValue={(option, value) => option?.id === value?.id}
                                            fullWidth
                                            renderInput={(params) =>
                                                <TextField {...params} size="small"
                                                    InputProps={{
                                                        ...params.InputProps,
                                                        endAdornment: (
                                                            <React.Fragment>
                                                                {statusSellers === ApiStatus.FETCHING && <CircularProgress color="inherit" size={20} />}
                                                                {params.InputProps.endAdornment}
                                                            </React.Fragment>
                                                        ),
                                                    }}
                                                />
                                            }
                                            onChange={(e, newValue) => {
                                                setSelectedSeller(newValue);
                                            }}
                                        />
                                    </Grid>
                                    <Grid item xs={6}>
                                        <FormLabel sx={{ color: '#000000' }}>Observación:</FormLabel>
                                        <TextField
                                            id="observation"
                                            type="text"
                                            name="observation"
                                            fullWidth
                                            size="small"
                                            value={observation}
                                            onChange={(e) => setObservation(e.target.value)}
                                        />
                                    </Grid>
                                </Grid>

                                <ModalFooter 
                                    buttonType="submit"
                                    confirmText={'Generar documento'}
                                    onConfirm={handleSubmit}
                                    onCancel={() => previousPannel()}
                                    cancelText={'Volver'}
                                />
                            </form>
                        )
                    }} 
                </Formik>
                </Grid>
                
            </CustomTabPanel>

        </Drawer>
    )
}
